import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { itemIdentifierAttribute } from 'products-data';
import { ItemPriceComponent } from 'products-ui';

@Component({
  selector: 'ideal-cart-item-price-view',
  imports: [ItemPriceComponent],
  standalone: true,
  templateUrl: './cart-item-price-view.component.html',
  styleUrl: './cart-item-price-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartItemPriceViewComponent {
  public readonly quantity = input.required<number>();
  public readonly itemId = input.required({
    transform: itemIdentifierAttribute,
  });
}
